var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c(_vm.label.startsWith('L') ? _vm.phaseIdxToColor(_vm.phase) : _vm.coloredInput[_vm.color], {
    tag: "component",
    staticClass: "input-box",
    attrs: {
      "id": _vm.resolvedInputId,
      "value": _vm.value,
      "size": "large",
      "placeholder": "Type in unit name",
      "disabled": _vm.disabled || !_vm.checked,
      "data-tn": `unit-input-${_vm.label}`
    },
    on: {
      "input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "addonBefore",
      fn: function () {
        return [_c('span', {
          staticClass: "label"
        }, [_vm._v(" " + _vm._s(_vm.label) + " ")])];
      },
      proxy: true
    }, _vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (scope) {
          return [_vm._t(slot, null, null, scope)];
        }
      };
    }), _vm.disabled ? {
      key: "suffix",
      fn: function () {
        return [_c('a-checkbox', {
          staticClass: "checkbox",
          attrs: {
            "checked": _vm.checked
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }), _vm.useIdealPostcodes ? _c('IdealPostcodesAutoComplete', {
    attrs: {
      "value": _vm.value,
      "checked": _vm.checked,
      "disabled": _vm.disabled,
      "input-id": _vm.resolvedInputId
    },
    on: {
      "input": _vm.onIdealInput,
      "entry-meta-change": _vm.onEntryMetaChange
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }